import api from '../lib/api';

const mediaService = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/media/upload/image', formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
  },

  uploadAudio: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/media/upload/audio', formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
  },

  uploadAvatar: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/media/upload/avatar', formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
  },
};

export default mediaService;
